import type { BundledMap } from '@yimoka/i18n';

import { i18n, registerFallbackLocaleResources } from './i18n';

const pendingResources: BundledMap[] = [];
let waitingForInitialization = false;

/** 向唯一的应用 i18n 实例增量注入模块或页面资源；初始化前调用会排队，避免 remote 自建实例。 */
export function registerLocaleResources(resources: BundledMap): void {
  registerFallbackLocaleResources(resources);
  if (!i18n.isInitialized) {
    pendingResources.push(resources);
    if (!waitingForInitialization) {
      waitingForInitialization = true;
      const handleInitialized = () => {
        i18n.off('initialized', handleInitialized);
        waitingForInitialization = false;
        pendingResources.splice(0).forEach(registerLocaleResources);
      };
      i18n.on('initialized', handleInitialized);
    }
    return;
  }

  Object.entries(resources).forEach(([language, namespaces]) => {
    Object.entries(namespaces).forEach(([namespace, bundle]) => {
      i18n.addResourceBundle(language, namespace, bundle, true, true);
    });
  });
}
